import { PreRegistrationRepository } from "@/domain/repository/pre-registration-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DeletePreRegistrationPatientUsecase {
  //MARK: Constructor
  constructor(private readonly preRegistrationRepo: PreRegistrationRepository) {}

  //MARK: execute
  async execute(patientUuid: string): Promise<SATResult<void, SATError>> {
    const result = await this.preRegistrationRepo.deletePreRegistration(patientUuid);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(undefined);
  }
}
